import React from 'react'
import toJS from '../hoc/toJS'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { FRONT, PROGRAM_CINEMAS, ROUTESDATA, THEME, TRANSLATION } from '../constants/state'
import getData from '../functions/getData'
import PerformanceSection from './PerformanceSection'
import PerformanceSectionWithoutMovieTimes from './PerformanceSectionWithoutMovieTimes'

const mapStateToProps = (state, ownProps) => ({
    routesData: getData(state, ROUTESDATA),
    cinemas: getData(state, PROGRAM_CINEMAS),
    cinemaDataFront: getData(state, FRONT),
    theme: getData(state, THEME)
})

const PerformanceSectionContainer = ({
    cinemaDataFront, 
    cinemas, 
    activeItem, 
    activePerformance,
    isMobile,
    theme,
    filterValue,
    filterType,
    moviesData,
    backgroundImage,
    scrollToPosition,
    currentDateActive,
    toggleMovieDatesOnMobileView,
    performancePageMovieTimes,
    onOpenPerformancePage,
    onClosePerformancePage,
    overviewFilterIgnoreOnPerformances,
    noMovietimes = false,
    hideCinemaSelector,
    queryStringValues
}) => {

    const {
        information_style
    } = cinemaDataFront

    const {
        theme_colors
    } = theme

    const currentCinema = cinemas[activePerformance.cinema]
    const cinemaDataProvider = currentCinema && currentCinema.scope.cinemaDataProvider

    if(noMovietimes) {
        return (
            <PerformanceSectionWithoutMovieTimes
                itemID={activeItem}
                cinemaDataProvider={cinemaDataProvider}
                theme={theme_colors}
                activePerformance={activePerformance}
                isMobile={isMobile}
                moviesData={moviesData}
                scrollToPosition={scrollToPosition}
                onClosePerformancePage={onClosePerformancePage}
            />
        )
    } else {
        return ( 
            <PerformanceSection
                informationStyling={information_style}
                itemID={activeItem}
                hideCinemaSelector={hideCinemaSelector}
                overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                cinemaDataProvider={cinemaDataProvider}
                activePerformance={activePerformance}
                queryStringValues={queryStringValues}
                isMobile={isMobile}
                theme={theme_colors}
                performancePageMovieTimes={performancePageMovieTimes}
                filterValue={filterValue}
                filterType={filterType}
                moviesData={moviesData}
                backgroundImage={backgroundImage}
                scrollToPosition={scrollToPosition}
                currentDateActive={currentDateActive}
                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                onOpenPerformancePage={onOpenPerformancePage}
                onClosePerformancePage={onClosePerformancePage}
            />
        )
    } 
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PerformanceSectionContainer)